import React, { useState } from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

import FaqPageContent from './FaqPageContent';

import css from './FaqPage.module.css';
import classNames from 'classnames';

const FaqPage = () => {

  const [currentTab, setCurrentTab] = useState('generalQuestions');

  const supportLink = <a href="mailto:info@eventify.lv" rel="noopener noreferrer">info@eventify.lv</a>;

  // prettier-ignore
  return (
    <StaticPage
      title="FAQ"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'FaqPage',
        description: 'FAQ',
        name: 'FAQ page',
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>
            <FormattedMessage id="FaqPage.title" />
          </h1>

          <ul className={css.pageTabs}>
            <li
              className={classNames(css.pageTabsItem, { [css.pageTabsItemActive]: currentTab === "generalQuestions" })}
              onClick={() => setCurrentTab('generalQuestions')}
            >
              <FormattedMessage id="FaqPage.generalQuestions" />
            </li>
            <li
              className={classNames(css.pageTabsItem, { [css.pageTabsItemActive]: currentTab === "providers" })}
              onClick={() => setCurrentTab('providers')}
            >
              <FormattedMessage id="FaqPage.providers" />
            </li>
            <li
              className={classNames(css.pageTabsItem, { [css.pageTabsItemActive]: currentTab === "users" })}
              onClick={() => setCurrentTab('users')}
            >
              <FormattedMessage id="FaqPage.users" />
            </li>
          </ul>

          <FaqPageContent currentTab={currentTab} />

          <p className={css.pageFooter}>
            <FormattedMessage id="FaqPage.didntFind" />
            <br />
            <FormattedMessage id="FaqPage.getInTouch" values={{ supportLink }} />
          </p>

        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default FaqPage;
